import React from 'react';
import PropTypes from 'prop-types';
import _intersection from 'lodash/intersection';

const FilterItem = ({
  activeFacetElements,
  activeMatches,
  element,
  facetMatches,
  name,
  checked,
  label,
  onChange
}) => {
  const matches = (activeFacetElements.length > 0)
    ? _intersection(activeMatches, facetMatches[element])
    : facetMatches[element];
  return (
    <li>
      <div className="checkbox sc__filter__checkbox">
        <label htmlFor={`${label}-${name}`}>
          <input
            id={`${label}-${name}`}
            type="checkbox"
            value={name}
            onChange={onChange}
            checked={checked}
          />
          <span className="input-override">
            <i className="zolaicon zolaicon-checkmark" />
          </span>
          {name} ({matches.length})
        </label>
      </div>
    </li>
  );
};

FilterItem.propTypes = {
  activeMatches: PropTypes.arrayOf(PropTypes.oneOfType(
    [PropTypes.number, PropTypes.string]
  )).isRequired,
  activeFacetElements: PropTypes.arrayOf(PropTypes.string),
  checked: PropTypes.bool,
  name: PropTypes.string,
  element: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  facetMatches: PropTypes.shape({})
};

export default FilterItem;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/GuestList/Filter/FilterItem.jsx